module.exports = __webpack_public_path__ + "assets/dots.693bf78b.svg";